import React from 'react';

/**
 * PlaybookImage - a professional, responsive image component for playbooks.
 * Props:
 *   src: string (required)
 *   alt: string (required)
 *   caption: string (optional)
 *   className: string (optional)
 */
const PlaybookImage = ({ src, alt, caption, className = '' }) => (
  <figure
    className={`w-full flex flex-col items-center my-6 bg-gray-900 border border-gray-700 rounded-xl shadow-lg p-4 max-w-3xl mx-auto ${className}`}
  >
    <div className="w-full overflow-hidden rounded-xl">
      <img
        src={src}
        alt={alt}
        className="w-full h-auto max-h-[480px] object-contain bg-transparent"
      />
    </div>
    {caption && (
      <figcaption className="mt-2 text-sm text-gray-400 text-center max-w-2xl">
        {caption}
      </figcaption>
    )}
  </figure>
);

export default PlaybookImage; 